import { useOutletContext } from "react-router-dom";

import SerieOverviewView from "../../views/SerieArticlesView/SerieOverviewView";

export default function SerieOverview() {
	const context = useOutletContext();

	return <SerieOverviewView {...context} />;
}
